var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.917 8.16663C12.6073 8.16663 13.167 7.60698 13.167 6.91663C13.167 6.22627 12.6073 5.66663 11.917 5.66663C11.2266 5.66663 10.667 6.22627 10.667 6.91663C10.667 7.60698 11.2266 8.16663 11.917 8.16663Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08398 8.16663C6.77434 8.16663 7.33398 7.60698 7.33398 6.91663C7.33398 6.22627 6.77434 5.66663 6.08398 5.66663C5.39363 5.66663 4.83398 6.22627 4.83398 6.91663C4.83398 7.60698 5.39363 8.16663 6.08398 8.16663Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00065 14C10.9007 14 12.5173 12.6166 13.1673 10.6666H4.83398C5.48398 12.6166 7.10065 14 9.00065 14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99199 0.666626C4.39199 0.666626 0.666992 4.39996 0.666992 8.99996C0.666992 13.6 4.39199 17.3333 8.99199 17.3333C13.6003 17.3333 17.3337 13.6 17.3337 8.99996C17.3337 4.39996 13.6003 0.666626 8.99199 0.666626ZM9.00033 15.6666C5.31699 15.6666 2.33366 12.6833 2.33366 8.99996C2.33366 5.31663 5.31699 2.33329 9.00033 2.33329C12.6837 2.33329 15.667 5.31663 15.667 8.99996C15.667 12.6833 12.6837 15.6666 9.00033 15.6666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiV2);
export default __webpack_public_path__ + "static/media/emojiV2.a1ee8691.svg";
export { ForwardRef as ReactComponent };